import { Link } from "react-router-dom";
import styles from "./DualPanel.module.css";

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const talentItems = [
  "Discover your strengths with AI insights",
  "Understand exactly what to improve",
  "Get matched to real job opportunities",
  "Stand out beyond your CV",
];

const employerItems = [
  "Reduce bad hires with verified signals",
  "Save time on screening — automatically",
  "Access pre-vetted, ready-to-hire candidates",
  "Make data-driven decisions, not guesses",
];

export default function DualPanel() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>Two sides, one platform</span>
          <h2 className={styles.h2}>One platform. Two clear missions.</h2>
          <p className={styles.sub}>
            Awasource works for both sides of the hiring equation — and every
            feature is designed with both in mind.
          </p>
        </div>

        <div className={styles.grid}>
          {/* ── Light panel: Talents ── */}
          <div className={`${styles.panel} ${styles.panelLight}`}>
            <span className={`${styles.panelTag} ${styles.panelTagLight}`}>
              For talents
            </span>
            <h3>Built for talents too</h3>
            <p className={styles.lead}>
              A profile that finally reflects your real ability — and the
              insights to grow it.
            </p>
            <ul className={styles.list}>
              {talentItems.map((item) => (
                <li key={item}>
                  <span className={`${styles.check} ${styles.checkLight}`}>
                    <CheckIcon />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <Link
              to="/login?tab=talent"
              className={`${styles.cta} ${styles.ctaLight}`}
            >
              For talents →
            </Link>
          </div>

          {/* ── Dark panel: Employers ── */}
          <div className={`${styles.panel} ${styles.panelDark}`}>
            <span className={`${styles.panelTag} ${styles.panelTagDark}`}>
              For employers
            </span>
            <h3>Designed for smarter hiring</h3>
            <p className={`${styles.lead} ${styles.leadDark}`}>
              Move from gut-feel decisions to confident, data-backed hires — at
              every stage.
            </p>
            <ul className={styles.list}>
              {employerItems.map((item) => (
                <li key={item} className={styles.itemDark}>
                  <span className={`${styles.check} ${styles.checkDark}`}>
                    <CheckIcon />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <Link to="/login" className={`${styles.cta} ${styles.ctaDark}`}>
              For employers →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
